export const useWreadiaSeo = (options: {
  title?: string | (() => string | undefined),
  description?: string | (() => string | undefined),
  image?: string | (() => string | undefined),
  ogType?: 'website' | 'article' | 'book' | 'profile',
  ogUrl?: string | (() => string | undefined),
  extra?: any
} = {}) => {
  const config = useRuntimeConfig();
  const route = useRoute();

  const defaultTitle = "Le club de la fiction indépendante";
  const defaultDescription = "Wreadia est le nouveau club de lecture de la fiction indépendante. Découvrez, lisez et soutenez les auteurs de demain.";
  const defaultImage = "/favicon/web-app-manifest-512x512.png"; // Or another suitable default image

  const title = computed(() => {
    const t = typeof options.title === 'function' ? options.title() : options.title;
    return t || defaultTitle;
  });

  const description = computed(() => {
    const d = typeof options.description === 'function' ? options.description() : options.description;
    return d || defaultDescription;
  });

  const image = computed(() => {
    const i = typeof options.image === 'function' ? options.image() : options.image;
    return i || `${config.public.siteUrl}${defaultImage}`;
  });

  const url = computed(() => {
    const u = typeof options.ogUrl === 'function' ? options.ogUrl() : options.ogUrl;
    return u || `${config.public.siteUrl}${route.path}`;
  });

  useSeoMeta({
    title: () => title.value,
    ogTitle: () => title.value,
    description: () => description.value,
    ogDescription: () => description.value,
    ogImage: () => image.value,
    ogUrl: () => url.value,
    ogType: options.ogType || 'website',
    ...options.extra
  });

  // Also set the head title for the browser tab
  useHead({
    title: () => title.value,
  });
};
